import { FlagIcon } from "../utils/countries.jsx";
import RankBadge from "./RankBadge.jsx";

const Initials = ({ name }) => {
  const letters = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
  return (
    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-glow/20 text-sm font-semibold text-brand-glow">
      {letters || "?"}
    </div>
  );
};

const LeaderboardTable = ({ entries, highlightUserId }) => {
  if (!entries?.length) {
    return (
      <p className="py-8 text-center text-sm text-white/40">No entries yet.</p>
    );
  }

  return (
    <ul className="divide-y divide-white/5">
      {entries.map((entry) => {
        const isMe = highlightUserId && entry.user_id === highlightUserId;
        return (
          <li
            key={entry.user_id}
            className={`flex items-center gap-4 px-4 py-3 ${
              isMe ? "rounded-xl bg-brand-glow/10 ring-1 ring-brand-glow/30" : ""
            }`}
          >
            <RankBadge rank={entry.rank} />
            {entry.avatar ? (
              <img
                src={entry.avatar}
                alt={entry.username}
                className="h-9 w-9 rounded-full object-cover"
              />
            ) : (
              <Initials name={entry.username} />
            )}
            <div className="min-w-0 flex-1">
              <p className="truncate font-semibold text-white">
                {entry.country && (
                  <FlagIcon code={entry.country} className="mr-1.5" />
                )}
                {entry.username}
                {isMe && (
                  <span className="ml-2 text-xs font-normal text-brand-glow">you</span>
                )}
              </p>
              {entry.badge_icons?.length > 0 && (
                <p className="mt-0.5 text-sm leading-none">
                  {entry.badge_icons.join(" ")}
                </p>
              )}
            </div>
            <div className="text-right">
              <p className="font-semibold text-white">{entry.points.toLocaleString()}</p>
              <p className="text-xs text-white/40">pts</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default LeaderboardTable;
